import EvalLozenge from './eval-lozenge';
export default EvalLozenge;
